import { motion } from 'framer-motion';
import React from 'react';
import styles from './Container.module.scss';

// Types
interface IProps {
	children: React.ReactNode;
	className?: string;
}

export const Container = React.forwardRef(
	({ children, className }: IProps, ref: React.Ref<HTMLDivElement>) => {
		return (
			<div
				ref={ref}
				className={`
				${styles['container']}
				${className ?? ''}
			`}
			>
				{children}
			</div>
		);
	},
);

export const MotionContainer = motion(Container);
